// React
import { useCallback, useMemo } from 'react';

// Kendo
import { Field, FieldWrapper } from '@progress/kendo-react-form';
import { Label } from '@progress/kendo-react-labels';

const Repeater = (props) => {
    const {
        className = '',
        fields = [],
        value = [],
        onChange,
        name,
        disabled = false,
        minRows = 1,
        maxRows = null
    } = props;

    const currentRows = useMemo(() => {
        if (!value || value.length === 0) {
            const emptyRow = {};
            fields.forEach(field => {
                emptyRow[field.name] = '';
            });
            return [emptyRow];
        }
        return value;
    }, [ value, fields ]);

    const addRow = useCallback(() => {
        if (maxRows && currentRows.length >= maxRows) {
            return;
        }

        const emptyRow = {};
        fields.forEach(field => {
            emptyRow[field.name] = '';
        });

        const newRows = [...currentRows, emptyRow];

        if (onChange) {
            onChange({ value: newRows });
        }
    }, [ currentRows, fields, onChange, maxRows ]);

    const removeRow = useCallback((rowIndex) => {
        if (currentRows.length <= minRows) {
            return;
        }

        const newRows = currentRows.filter((_, index) => index !== rowIndex);

        if (onChange) {
            onChange({ value: newRows });
        }
    }, [ currentRows, onChange, minRows ]);

    const renderLabel = (field, rowIndex) => {
        if (field.labelAction) {
            const LabelActionComponent = field.labelAction;

            return (
                <Label className="k-form-label" style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', width: '100%' }}>
                    <span>{field.label}</span>
                    <LabelActionComponent rowIndex={rowIndex} />
                </Label>
            );
        }
        return <Label className="k-form-label">{field.label}</Label>;
    }

    return (
        <div className="k-d-grid k-grid-cols-12 k-gap-xl">
            { currentRows && currentRows.length > 0 && currentRows.map((row, rowIndex) => {
                return (
                    <div key={rowIndex} className="k-col-span-12 k-d-grid k-grid-cols-12 k-gap-xl">
                        { fields && fields.length > 0 && fields.map((field, fieldIndex) => (
                            <div key={ `${rowIndex}-${fieldIndex}` } className={ field.className }>
                                <fieldset className="k-form-fieldset">
                                    <FieldWrapper>
                                        { renderLabel(field, rowIndex) }
                                        <div className="k-form-field-wrap">
                                            <Field
                                                name={ `${name}[${rowIndex}].${field.name}` }
                                                component={ field.component }
                                                { ...( (({name, component, label, className, labelAction, ...rest}) => rest)(field) ) }
                                            />
                                        </div>
                                    </FieldWrapper>
                                </fieldset>
                            </div>
                        ))}

                        { currentRows.length > 1 &&
                            <div className="k-col-span-1 k-d-flex k-flex-column k-justify-content-end">
                                <div className="k-py-sm k-text-secondary">
                                    <span className="k-icon k-font-icon k-i-x-outline k-cursor-pointer" onClick={ () => removeRow(rowIndex) }></span>
                                </div>
                            </div>
                        }
                    </div>
                )
            })}

            <div className="k-col-span-12">
                <span className="k-icon k-font-icon k-i-add-outline k-cursor-pointer" onClick={ addRow }></span>
            </div>
        </div>
    );
};

export default Repeater;
